module.exports = __webpack_public_path__ + "img/registerUser-blog-unsupported - Copy.092e42bc.png";